import { render, staticRenderFns } from "./uniPageParam.vue?vue&type=template&id=3261f10e"
import script from "./uniPageParam.vue?vue&type=script&lang=js"
export * from "./uniPageParam.vue?vue&type=script&lang=js"
import style0 from "./uniPageParam.vue?vue&type=style&index=0&id=3261f10e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports